import React from 'react'
import { Container } from 'reactstrap'
import { Section, Paragraph, Panel } from '../../GlobalStyles'
import styled from 'styled-components'
import theme from '../../theme'

export const CustomSection = styled(Section)`
  position: relative;
  z-index: 10;
  padding-bottom: 0px;
  @media screen and (min-width: 1025px) {
    padding-top: 0;
  }
`
export const CustomPanel = styled(Panel)`
  position: relative;
  top: -32px;
  @media (min-width: 1024px) {
    top: -64px;
  }
`

export const ContainerLg = styled(Container)`
  @media (min-width: 1345px) {
    max-width: 1345px !important;
  }
`

const OverviewSection = props => {
  return (
    <CustomSection bgColor={theme.colors.lightenGray}>
      <Container>
        <CustomPanel padding='64px 64px'>
          <Paragraph marginBottom='0'>
            "PGA Coach is your one-stop-shop for coaching tools and resources.
            Our goal is to provide you with the information you need to grow
            both your business and the game of golf."
          </Paragraph>
        </CustomPanel>
      </Container>
    </CustomSection>
  )
}

export default OverviewSection
